<template>
    <div class="used-results__notifications" v-if="notifications.length > 0">
        <div class="used-results__notification" v-for="(notification, key) in notifications" :key="key" :notification="notification" v-once>
            {{ notification }}
            <button type="button" @click="dismiss(notification)" class="used-results__notification-dismiss" data-dismiss="modal" aria-label="Dismiss"><span class="used-results__notification-dismiss-span" aria-hidden="true">&times;</span></button>
        </div>
    </div>
</template>

<script>
    import { mapState } from "vuex";

    export default {
        computed: {
            ...mapState("UsedSearchOptions", ["notifications"]),
        },

        methods: {
            dismiss(notification) {
                this.$store.commit('UsedSearchOptions/clearNotification', notification);
            }
        },

        beforeDestroy() {
            this.$store.commit('UsedSearchOptions/clearAllNotifications');
        }
    };
</script>


// WEBPACK FOOTER //
// resources/assets/js/used-vue/components/Notifications.vue